import type { QuizQuestionFormat } from "./quiz-question-format";

/**
 * Soft answer-time budget (lock F). Used for speedFactor MP bonus and P6 soft bar.
 * `8s + 40ms/char + 1.2s/option + 2s/blank`, clamp 6s–45s; TYPE_ANSWER floor 12s.
 */
export function computeQuizAnswerBudgetMs(params: {
	format: QuizQuestionFormat;
	questionText: string;
	optionCount?: number;
	blankCount?: number;
}): number {
	const promptChars = Math.max(0, (params.questionText ?? "").length);
	const optionCount = Math.max(0, Math.floor(params.optionCount ?? 0));
	const blankCount = Math.max(0, Math.floor(params.blankCount ?? 0));
	let ms =
		8_000 + 40 * promptChars + 1_200 * optionCount + 2_000 * blankCount;
	ms = Math.min(45_000, Math.max(6_000, ms));
	if (params.format === "TYPE_ANSWER") {
		ms = Math.max(ms, 12_000);
	}
	return Math.floor(ms);
}

/** `clamp(remainingBudgetMs / budgetMs, 0, 1)` from response time vs budget. */
export function computeQuizAnswerSpeedFactor(params: {
	responseTimeMs: number;
	budgetMs: number;
}): number {
	const budgetMs = Math.max(1, params.budgetMs);
	const responseTimeMs = Math.max(
		0,
		Number.isFinite(params.responseTimeMs) ? params.responseTimeMs : 0,
	);
	const remaining = budgetMs - responseTimeMs;
	if (remaining <= 0) {
		return 0;
	}
	if (remaining >= budgetMs) {
		return 1;
	}
	return remaining / budgetMs;
}
